export const configurationChangelogPath = () =>
  '/settings/configuration-changelog' as const;

export const configurationChangelogDetailRoute =
  `${configurationChangelogPath()}/:versionId` as const;

export const configurationChangelogDetailPath = (versionId: number) =>
  `${configurationChangelogPath()}/${versionId}` as const;
